import { render, staticRenderFns } from "./PackagingSection.vue?vue&type=template&id=60c83d24&scoped=true&"
import script from "./PackagingSection.vue?vue&type=script&lang=js&"
export * from "./PackagingSection.vue?vue&type=script&lang=js&"
import style0 from "./PackagingSection.vue?vue&type=style&index=0&id=60c83d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c83d24",
  null
  
)

export default component.exports